// This page is Header for all pages
<template>
    <div class="max-h-screen bg-white">
      <div class="notification-bar" v-if="$route.path === '/login' || $route.path === '/sign-in'">
        <p>
          U.S. Legal Services has a new look. Same trusted legal protection. Simplified, more modern access.
          <a href="https://hello.uslegalservices.net/the-new-u.s.-legal-services" target="_blank">
            Read more about our transformation
          </a>
        </p>
      </div>
    <nav class="bg-white border-b border-gray-200">
      <div class="max-w-10xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-16">
          <div class="flex">
            <div class="flex-shrink-0 flex items-center">
              <img
                class="h-6 w-auto sm:h-8 md:h-6 lg:hidden block"
                src="@/assets/Images/USL_bridge_stacked_positive.png"
                alt="U.S.Legal"
              />
              <img
                class="hidden lg:block h-14 w-auto"
                src="@/assets/Images/USL_bridge_stacked_positive.png"
                alt="U.S.Legal"
              />
            </div>
            <div class="hidden sm:-my-px sm:ml-6 sm:flex md:space-x-5 xl:space-x-8">
              <router-link
                to="/home"
                v-if="
                  att_user?.data?.password != null &&
                    att_user?.data?.password != ''
                "
                class="border-[#ce4c29] text-gray-500 hover:border-[#ce4c29] hover:text-[#ce4c29] inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
              >Home</router-link>

              <router-link
                v-if="
                  att_user?.data?.password != null &&
                    att_user?.data?.password != ''
                "
                to="/update-profile/primary"
                class="border-transparent text-gray-500 hover:border-[#ce4c29] hover:text-[#ce4c29] inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
              >Profile</router-link>
              <router-link
                v-if="
                  att_user?.data?.password == null ||
                    att_user?.data?.password == ''
                "
                to="/login"
                class="border-transparent text-gray-500 hover:border-[#ce4c29] hover:text-[#ce4c29] inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
              >Register/Login</router-link>
              <router-link
                to="/signing"
                v-if="
                  attorney_data?.id != null &&
                    attorney_data?.id != '' && !attorney_data?.signed && (att_user?.data?.password == null ||
                    att_user?.data?.password == '')
                "
                class="border-transparent text-gray-500 hover:border-[#ce4c29] hover:text-[#ce4c29] inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
              >Sign Application</router-link>
              <router-link
                v-if="
                  leadData?.result?.lead != undefined &&
                    leadData?.result?.lead[0]?.attorney_id == null
                "
                to="/application"
                class="border-transparent text-gray-500 hover:border-[#ce4c29] hover:text-[#ce4c29] inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
              >Application</router-link>
              <router-link
                v-if="
                  att_user?.data?.password != null &&
                    att_user?.data?.password != ''
                "
                to="/claims"
                class="border-transparent text-gray-500 hover:border-[#ce4c29] hover:text-[#ce4c29] inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
              >Claims</router-link>
              <router-link
                v-if="
                  att_user?.data?.password != null &&
                    att_user?.data?.password != ''
                "
                to="/authorizations"
                class="border-transparent text-gray-500 hover:border-[#ce4c29] hover:text-[#ce4c29] inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
              >Authorization Requests</router-link>
              <router-link
                v-if="
                  att_user?.data?.password != null &&
                    att_user?.data?.password != ''
                "
                to="/cases"
                class="border-transparent text-gray-500 hover:border-[#ce4c29] hover:text-[#ce4c29] inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
              >Cases</router-link>
              <router-link
                v-if="
                  leadData?.result?.lead == undefined &&
                    (att_user?.data?.password == null ||
                      att_user?.data?.password == '')
                "
                to="/sign-in"
                class="border-transparent text-gray-500 hover:border-[#ce4c29] hover:text-[#ce4c29] inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
              >Join Our Network</router-link>
              <router-link
                v-if="
                  att_user?.data?.password != null &&
                    att_user?.data?.password != ''
                "
                to="/help_information"
                class="border-transparent text-gray-500 hover:border-[#ce4c29] hover:text-[#ce4c29] inline-flex items-center px-1 pt-1 md:text-xs xl:text-sm font-medium"
              >Helpful Information</router-link>
            </div>
          </div>
          <div
            class="hidden sm:ml-6 sm:flex sm:items-center"
            v-if="
              leadData?.result?.lead != undefined ||
                (att_user?.data?.password != null &&
                  att_user?.data?.password != '')
            "
          >
            <div class="ml-3 relative">
              <div>
                <button
                  class="max-w-xs bg-white flex items-center md:text-xs xl:text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1f3341]"
                  id="user-menu"
                  aria-controls="user-menu-item"
                  aria-haspopup="true"
                  @click="openPopup"
                >
                  <span class="sr-only">Open user menu</span>
                  <div class="ml-3">
                    <div
                      class="md:text-xs xl:text-sm font-medium text-[#1f3341] hover:text-[#ce4c29]"
                      v-if="
                        att_user?.data?.password != null &&
                          att_user?.data?.password != ''
                      "
                    >
                      <span
                        id="user-email"
                        class="w-full"
                        v-if="
                          att_user?.data?.email != '' &&
                            att_user?.data?.email != null
                        "
                      >
                        <i class="fa fa-user mr-1"></i>
                        {{ att_user?.data?.email }}
                      </span>
                      <span
                        id="user-email"
                        class="w-full"
                        v-if="
                          att_user?.data?.email == '' ||
                            att_user?.data?.email == null
                        "
                      >
                        <i class="fa fa-user mr-1"></i>
                        {{ att_user?.data?.first_name }}
                        {{ att_user?.data?.last_name }}
                      </span>
                    </div>
                    <div
                      id="user-email"
                      class="md:text-xs xl:text-sm font-medium text-gray-700 w-full"
                      v-if="
                        att_user?.data == undefined &&
                          leadData?.result?.lead != undefined
                      "
                    >
                      <i class="fa fa-user mr-1"></i>
                      {{ leadData?.result?.lead[0]?.email }}
                    </div>
                  </div>
                </button>
                <div
                  class="active-header origin-top-right absolute mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5"
                  role="menu"
                  id="user-menu-item"
                  aria-orientation="vertical"
                  aria-labelledby="user-menu"
                >
                  <router-link
                    to="/change-settings"
                    v-if="
                      att_user?.data?.password != null &&
                        att_user?.data?.password != ''
                    "
                    class="block px-4 py-2 md:text-xs xl:text-sm text-gray-700 hover:text-[#ce4c29] hover:bg-gray-100"
                  >User Settings</router-link>
                  <a
                    v-if="
                      (att_user?.data?.password != null &&
                        att_user?.data?.password != '') ||
                        leadData?.result?.lead?.length != 0
                    "
                    href="#"
                    class="block px-4 py-2 md:text-xs xl:text-sm text-gray-700 hover:text-[#ce4c29] hover:bg-gray-100"
                    role="menuitem"
                    @click="signOut"
                  >Sign out</a>
                </div>
              </div>
            </div>
          </div>
          <div class="-mr-2 flex items-center sm:hidden">
            <button
              @click="openSubMenu"
              class="bg-white inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <span class="sr-only">Open main menu</span>
              <svg
                class="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <svg
                class="hidden h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="hidden sm:hidden" id="mobile-view-menu">
        <div class="pt-2 pb-3 space-y-1">
          <router-link
            to="/home"
            v-if="
              att_user?.data?.password != null && att_user?.data?.password != ''
            "
            class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#ce4c29] hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
          >Home</router-link>
          <router-link
            to="/update-profile/primary"
            v-if="
              att_user?.data?.password != null && att_user?.data?.password != ''
            "
            class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#ce4c29] hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
          >Profile</router-link>
          <router-link
            v-if="
              att_user?.data?.password == null || att_user?.data?.password == ''
            "
            to="/login"
            class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#ce4c29] hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
          >Register/Login</router-link>
          <router-link
            v-if="
              leadData?.result?.lead != undefined &&
                leadData?.result?.lead[0].attorney_id == null
            "
            to="/application"
            class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#ce4c29] hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
          >Application</router-link>
          <router-link
            to="/signing"
            v-if="
                  attorney_data?.id != null &&
                    attorney_data?.id != '' && !attorney_data?.signed && (att_user?.data?.password == null ||
                    att_user?.data?.password == '')
                "
            class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#ce4c29] hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
          >Sign Application</router-link>
          <router-link
            v-if="
              att_user?.data?.password != null && att_user?.data?.password != ''
            "
            to="/claims"
            class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#ce4c29] hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
          >Claims</router-link>
          <router-link
            v-if="
              att_user?.data?.password != null && att_user?.data?.password != ''
            "
            to="/authorizations"
            class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#ce4c29] hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
          >Authorization Requests</router-link>
          <router-link
            v-if="
              att_user?.data?.password != null && att_user?.data?.password != ''
            "
            to="/cases"
            class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#ce4c29] hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
          >Cases</router-link>

          <router-link
            v-if="leadData?.result?.lead == undefined && att_user.length == 0"
            to="/sign-in"
            class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#ce4c29] hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
          >Join Our Network</router-link>
          <router-link
            v-if="
              att_user?.data?.password != null && att_user?.data?.password != ''
            "
            to="/help_information"
            class="border-transparent text-gray-600 hover:bg-gray-50 hover:border-[#ce4c29] hover:text-gray-800 block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
          >Helpful Information</router-link>
        </div>
        <div class="pt-4 pb-3 border-t border-gray-200">
          <div class="flex items-center">
            <div
              class="ml-3"
              v-if="
                (att_user?.data?.password != null &&
                  att_user?.data?.password != '') ||
                  leadData?.result?.lead?.length != 0
              "
            >
              <div
                class="md:text-xs xl:text-sm font-medium text-gray-500"
                v-if="
                  att_user?.data?.password != null &&
                    att_user?.data?.password != ''
                "
              >
                <span
                  id="user-email"
                  class="w-full"
                  v-if="
                    att_user?.data?.email != '' && att_user?.data?.email != null
                  "
                >
                  <i class="fa fa-user mr-1"></i>
                  {{ att_user?.data?.email }}
                </span>
                <span
                  id="user-email"
                  class="w-full"
                  v-if="
                    att_user?.data?.email == '' || att_user?.data?.email == null
                  "
                >
                  <i class="fa fa-user mr-1"></i>
                  {{ att_user?.data?.first_name }}
                  {{ att_user?.data?.last_name }}
                </span>
              </div>
              <div
                id="user-email"
                class="md:text-xs xl:text-sm font-medium text-gray-500 w-full"
                v-if="
                  att_user?.data == undefined &&
                    leadData?.result?.lead != undefined
                "
              >
                <i class="fa fa-user mr-1"></i>
                {{ leadData?.result?.lead[0]?.email }}
              </div>
            </div>
          </div>
          <div class="mt-3 space-y-1">
            <router-link
              to="/change-settings"
              v-if="
                att_user?.data?.password != null &&
                  att_user?.data?.password != ''
              "
              class="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
            >User Settings</router-link>

            <a
              v-if="
                (att_user?.data?.password != null &&
                  att_user?.data?.password != '') ||
                  leadData?.result?.lead?.length != 0
              "
              href="#"
              @click="signOut"
              class="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
            >Sign out</a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import $ from "jquery";
import { mapState } from "vuex";
export default {
  name: "Header",
  computed: mapState(["leadData", "att_user", "attorney_data"]),
  mounted: function() {
    var isMenuOpen = false;
    $("#nav-toggle").click(function() {
      isMenuOpen = !isMenuOpen;
      $(this).attr("aria-expanded", isMenuOpen);
      $("#nav-content").attr("aria-expanded", isMenuOpen);
    });
    $("body").click(function(event) {
      if (event.target.id != "user-email") {
        $("#user-menu-item").addClass("active-header");
      }
    });
  },
  methods: {
    openSubMenu: function() {
      $("#mobile-view-menu").toggleClass("hidden");
    },
    openPopup: function() {
      $("#user-menu-item").toggleClass("active-header");
    },
    signOut: function() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    }
  }
};
</script>
